export default __webpack_public_path__ + "static/apercu-regular-8c2a1e77db4d74cb7ece9994e60707db.woff";